import { Tag } from '../Tag';

function WarrantyTag() {
  return <Tag text="Warranty" textColor="GREY_DARK" bgColor="GREY_LIGHTER" />;
}

export { WarrantyTag };
